module.exports = __webpack_public_path__ + "static/media/Icon_Back.2cd1443e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/ProductImage/icons/Icon_Back.svg
// module id = 1731
// module chunks = 0